/* FA FAQ – accordion accessible, works with Theme Editor reloads */
(() => {
  function init(root = document) {
    // default: semua panel hidden
    root.querySelectorAll('.fa-accordion__panel').forEach(p => { p.hidden = true; });

    // Delegation: klik di mana pun, cari tombol terdekat
    root.addEventListener('click', e => {
      const btn = e.target.closest('.fa-accordion__trigger');
      if (!btn || !root.contains(btn)) return;

      // Cari panel via aria-controls; kalau tak ada, fallback ke sibling di item
      let panel = null;
      const id = btn.getAttribute('aria-controls');
      if (id) panel = document.getElementById(id);
      if (!panel) {
        const item = btn.closest('.fa-accordion__item');
        if (item) panel = item.querySelector('.fa-accordion__panel');
      }

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panel) panel.hidden = expanded;
    });
  }

  // Inisialisasi
  document.addEventListener('DOMContentLoaded', () => init());

  // Support reload section di Theme Editor
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
